import { render, staticRenderFns } from "./RefundWorkList.vue?vue&type=template&id=71861070&scoped=true&"
import script from "./RefundWorkList.vue?vue&type=script&lang=js&"
export * from "./RefundWorkList.vue?vue&type=script&lang=js&"
import style0 from "./RefundWorkList.vue?vue&type=style&index=0&id=71861070&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71861070",
  null
  
)

export default component.exports